import ProFormTags from './ProFormTags';

export default ProFormTags;
